module.exports = __webpack_public_path__ + "img/symbol_2.9fc875f7.png";